// extracted by mini-css-extract-plugin
export default {"box":"icon-module--box--1bfd5","svg":"icon-module--svg--e3719"};